export * from "./src/tabs-with-cards.pattern";
